import {AuthActions, AuthActionTypes} from '../actions/auth.actions';
import {LoginResponse, User} from '../models/auth';
import {ErrorPayload} from '../models/general';

export interface State {
  accessToken: string | null;
  isLoginLoading: boolean;
  isLoginLoaded: boolean;
  loginError: string | null;
  user: User | null;
}

export const initialState: State = {
  accessToken: localStorage.getItem('access_token') || null,
  isLoginLoading: false,
  isLoginLoaded: localStorage.getItem('access_token') != null,
  loginError: null,
  user: JSON.parse(localStorage.getItem('self')) || null
};

export function reducer(state = initialState, action: AuthActions): State {
  switch (action.type) {

    case AuthActionTypes.Login: {
      return {
        ...state,
        isLoginLoading: true,
        isLoginLoaded: false,
        loginError: null,
        user: null
      };
    }

    case AuthActionTypes.LoginComplete: {
      const loginResponse: LoginResponse = action.payload;
      const _user: User = {
        id: parseInt(loginResponse.id, 10),
        email: loginResponse.email,
        firstName: loginResponse.firstName,
        lastName: loginResponse.lastName,
        dobYear: loginResponse.dobYear,
        dobMonth: loginResponse.dobMonth,
        dobDay: loginResponse.dobDay,
        gender: loginResponse.gender
      };

      return {
        ...state,
        user: _user,
        accessToken: loginResponse.accessToken,
        isLoginLoading: false,
        isLoginLoaded: true
      };
    }

    case AuthActionTypes.LoginError: {
      const errorPayload: ErrorPayload = action.payload;

      return {
        ...state,
        isLoginLoading: false,
        loginError: errorPayload.errorMessage
      };
    }

    case AuthActionTypes.LogoutSuccess: {
      return {
        ...state,
        accessToken: null,
        isLoginLoaded: false,
        loginError: null,
        user: null
      };
    }

    default:
      return state;
  }
}

export const accessToken = (state: State) => state.accessToken;
export const isLoginLoading = (state: State) => state.isLoginLoading;
export const isLoginLoaded = (state: State) => state.isLoginLoaded;
export const loginError = (state: State) => state.loginError;
export const user = (state: State) => state.user;
